// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__Ii1qK","toolbar":"Text_toolbar__3PHoq","toolbarButton":"Text_toolbarButton__3FJGs","editor":"Text_editor__3oUcV","flex1":"Text_flex1__l6ZZ2"};